import { useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { FormatDateDayLastMonth } from "src/shared/Utils/FormatDate/FormatDateDayLastMonth";
import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { api } from "src/shared/setup/API/api";

import {
  IReportContractsToInstallmentsFilters,
  IReportContractsToInstallmentsResponse,
} from "../types";

const defaultFilters: IReportContractsToInstallmentsFilters = {
  start_date: `${FormatDateDayLastMonth().firstDayMonth}`,
  end_date: `${GetDateUSSemValue()}`,
  type_date: "ASSINATURA",
  nome: "",
  cpf_cnpj: "",
  cod_proposta: "",
};

export const useReportContractsToInstallments = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState<IReportContractsToInstallmentsResponse>();
  const [filters, setFilters] =
    useState<IReportContractsToInstallmentsFilters>(defaultFilters);
  const [submittedFilters, setSubmittedFilters] =
    useState<IReportContractsToInstallmentsFilters>(defaultFilters);

  const handleSubmit = async () => {
    setReport(undefined);

    const payload = {
      start_date: filters.start_date || undefined,
      end_date: filters.end_date || undefined,
      type_date: filters.type_date || undefined,
      nome: filters.nome.trim() || undefined,
      cpf_cnpj: filters.cpf_cnpj.trim() || undefined,
      cod_proposta: filters.cod_proposta.trim() || undefined,
    };

    return api
      .post<IReportContractsToInstallmentsResponse>(
        "/report/contractsToInstallments",
        payload
      )
      .then((res) => {
        setReport(res.data);
        setSubmittedFilters(filters);
      })
      .catch((error) => {
        handleGetAlert({
          message:
            error?.response?.data?.message ||
            "Não foi possível gerar o relatório.",
        });
      })
      .finally(() => setLoading(false));
  };

  const handleClearFilters = () => {
    setFilters(defaultFilters);
    setSubmittedFilters(defaultFilters);
    setReport(undefined);
  };

  return {
    loading,
    report,
    filters,
    submittedFilters,
    setFilters,
    handleSubmit,
    handleClearFilters,
  };
};
